@if (!editEnabled) {
  <odx-card class="container" (interact)="onClick()" variant="launch-tile-centered">
    @if ((isReadOnlyUser$ | async) === false) {
      <odx-menu>
        <button
          odxButton
          odxMenuItem
          [disabled]="(hasWritePermission$ | async) === false"
          (click)="$event.stopPropagation(); onEdit()"
        >
          <odx-icon name="edit" size="medium" alignleft></odx-icon>
          <span i18n="@@global.edit">Bearbeiten</span>
        </button>

        <button
          odxButton
          odxMenuItem
          [disabled]="(hasWritePermission$ | async) === false"
          (click)="$event.stopPropagation(); onDelete()"
        >
          <odx-icon name="delete" size="medium" alignleft></odx-icon>
          <span i18n="@@global.delete">Löschen</span>
        </button>
      </odx-menu>
    }
    <div odxLayout="flex" class="content flex-column">
      <div>
        <h6 class="odx-title-6 card-title">{{ fileName }}</h6>
        @if ((isMonitoringScope$ | async) === true && tags?.length) {
          <div class="tag-container">
            @for (tag of tags; track tag) {
              <odx-chip removable="false" size="small" variant="secondary" class="chip">
                {{ tag | translateProjectImageTag }}
              </odx-chip>
            }
          </div>
        }
      </div>

      <div class="file-wrapper">
        @if (fileUrl) {
          <img [src]="fileUrl" [alt]="fileName" />
        }
      </div>

      @if ((isMonitoringScope$ | async) === true && description) {
        <div class="description">
          <div class="odx-title-6">Beschreibung</div>
          <p>{{ description }}</p>
        </div>
      }
    </div>
  </odx-card>
} @else {
  <odx-content-box class="file-content-box">
    <form odxForm [formGroup]="editForm">
      @if ((isMonitoringScope$ | async) === true) {
        <odx-form-field i18n-label="@@imageCard.editFormLocation.label" label="Ort" odxLayout="6">
          <input
            formControlName="name"
            odxFormFieldControl
            placeholder="Ort"
            i18n-placeholder="@@imageCard.editFormLocation.placeholder"
          />
        </odx-form-field>

        <odx-form-field i18n-label="@@imageCard.editFormTags.label" label="Tags" odxLayout="6">
          <odx-select multiple formControlName="tags" odxFormFieldControl>
            @for (item of tagList$ | async | odxAutocompleteSearchFilter; track item) {
              <odx-select-option [value]="item">
                {{ item | translateProjectImageTag }}
              </odx-select-option>
            }
            <input
              placeholder="Nach Tag suchen..."
              i18n-placeholder="@@imageCard.editFormTags.placeholder"
              odxSelectSearchField="Kein Tag gefunden"
              i18n-odxSelectSearchField="@@imageCard.editFormTags.noResult"
            />
          </odx-select>
        </odx-form-field>
      } @else {
        <odx-form-field i18n-label="@@imageCard.editFormName.label" label="Name" odxLayout="6">
          <input
            formControlName="name"
            odxFormFieldControl
            placeholder="Name"
            i18n-placeholder="@@imageCard.editFormName.placeholder"
          />
        </odx-form-field>
      }

      <div class="file-wrapper">
        @if (fileUrl) {
          <img [src]="fileUrl" [alt]="fileName" />
        }
      </div>

      @if ((isMonitoringScope$ | async) === true) {
        <odx-form-field i18n-label="@@imageCard.editFormDescription.label" label="Beschreibung">
          <textarea formControlName="description" odxFormFieldControl></textarea>
        </odx-form-field>
      }

      <div class="button-container">
        <button odxButton variant="secondary" (click)="cancelEditMode()" i18n="@@global.dismiss">Abbrechen</button>

        <button odxButton variant="secondary" (click)="onDelete()" i18n="@@global.delete">Löschen</button>

        <button
          odxButton
          variant="primary"
          type="submit"
          class="save-button"
          (click)="$event.stopPropagation(); onSubmit()"
          i18n="@@global.save"
        >
          Speichern
        </button>
      </div>
    </form>
  </odx-content-box>
}
